export const API_URL = //"http://139.59.93.36:3001";
//  "http://localhost:4000";
  //"https://devupi.xseller8.org";
 // "https://genie-backend.testbase.online";
 // "https://genie-backend.trythis.online";
  "https://api.xseller8.org";
 //  "http://54.246.227.215:4000";
// "http://34.245.239.29:4100"
   // "http://localhost:4000";
export const URLDATA = { 
  url: API_URL + "/graphql",
  queryFile: ""
};
export const URLDATA2 = {
  url: API_URL + "/graphql",
  uploadUrl: API_URL + "/api/Containers/files/upload",
  queryFile: ""
};
// export const URLDATA2 = {
//   url: API_URL + "/graphql",
//   uploadUrl: API_URL + "/api/Containers/files/upload",
//   queryFile: ""
// };
export const MoveToContact = {
  url: API_URL + "/api/Usersdata/moveContactsData?contactArray=",

  token: localStorage.getItem("token"),
  createdBy: localStorage.getItem("id")
};
export const RemoveToContact = {
  url: API_URL + "/api/Usersdata/removeContactsData?contactArray=",

  token: localStorage.getItem("token"),
  createdBy: localStorage.getItem("id")
};

export const RemoveToContactUpdate = {
  url: API_URL + "/api/Usersdata/updateContactsData?contactArray=",

  token: localStorage.getItem("token"),
  createdBy: localStorage.getItem("id")
};

export const getContactImageUrl = {
  url: API_URL + "/api/Containers/imagefiles/download/"
};
export const getContactImageUrl2 = {
  url: API_URL + "/api/Containers/imagefiles2/download/"
};
export const MoveAllContactToTemp = {
  url: API_URL + "/api/Usersdata/moveAllContactToTemp?campaignId=",
  token: localStorage.getItem("token")
};
export const ResetPassword = {
  url: API_URL + "/api/Usersdata/forgotPassword?email="
};

export const profileImageUrl = {
  url: API_URL + "/api/Usersdata/upload?access_token="
};
export const campaignImageUrl = {
  url: API_URL + "/api/Campaigns/upload?access_token="
};

export const getProfileImageUrl = {
  url: API_URL + "/api/Containers/files/download/"
};
export const getCampaignImageUrl = {
  url: API_URL + "/api/Containers/campaignslogo/download/"
};
export const salesforceApi = {
  url:
    API_URL + "/api/Customerlinkedinprofiles/SalesForcePostData?contactArray="
};

export const hubspotApi = {
  url: API_URL + "/api/Customerlinkedinprofiles/HubspotPostData?contactArray="
};

// ("use strict");

// var pkg = require("./package.json");
// var Greenlock = require("greenlock");
// var greenlock = Greenlock.create({
//   configDir: "./greenlock.d/config.json",
//   packageAgent: pkg.name + "/" + pkg.version,
//   maintainerEmail: pkg.author,
//   staging: true,
//   notify: function(event, details) {
//     if ("error" === event) {
//       // `details` is an error object in this case
//       console.error(details);
//     }
//   }
// });

// greenlock.manager
//   .defaults({
//     agreeToTerms: true,
//     subscriberEmail: "webhosting@example.com"
//   })
//   .then(function(fullConfig) {
//     // ...
//   });
